<div class="ct-container">
  <div class="ct-main-content">
    <div class="open-hours">
      @if (!logoPath) {
        <div class="title">
          {{deparameterize(company.name)}}
        </div>
      }
      @if (company.delivery_hours) {
        <div class="body">
          <div class="logo-container">
            @if (logoPath) {
              <img [src]="logoPath"/>
            }
          </div>
          <br/>
          <!-- Status info (closed, open, etc) -->
          <div class="status-info">
            <div class="status-dot" [class.top-a-bit]="company.deliveryStatus != 'open'">
              <span class="dot {{company.deliveryStatus}}"></span>
            </div>
            <div class="status-text" [class.top-a-bit]="company.deliveryStatus == 'open'">
              <span class="status-ptbr">
                {{deliveryStatusPtbr}}
              </span>
              <br/>
              @if (company.deliveryStatus == 'closed' && company.delivery_eta != -1) {
                <span class="time-at">
                  (Abre <span>{{nextShiftDeliveryPtbr.day}}</span> às {{nextShiftDeliveryPtbr.opens}})
                </span>
              }
              @if (company.deliveryStatus == 'closing') {
                <span class="time-at">
                  (Fecha às {{company.currentShift.closesAt}})
                </span>
              }
              @if (company.deliveryStatus == 'opening') {
                <span class="time-at">
                  (Abre às {{nextShiftDeliveryPtbr.opens}})
                </span>
              }
            </div>
          </div>
          <!-- ETA info -->
          @if (company.delivery_eta) {
            <div class="eta-info">
              <hr/>
              @if (company.deliveryStatus != 'closed' && !(company.delivery_eta < 0)) {
                <span>
                  Tempo Estimado: <span class="eta-time">{{company.delivery_eta}} minutos</span>
                </span>
              }
              @if (company.delivery_eta < 0) {
                <span>
                  Delivery <span class="eta-time">encerrado temporariamente</span> por agora
                </span>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>